import { IUISupplier } from '@bridebook/toolbox/src/types';
import { Box } from '@bridebook/ui';
import SupplierUpdateTag from '@bridebook/web/app-shared/components/supplier/sections/supplier-update-tag';
import msg, { MsgKey } from '@bridebook/web/app-shared/lib/supplier/msg';
import componentStyles from './index.style';
import { venueFeatures, venueStyles, venueTypes } from './supported-tags';

interface IProps {
  supplier: IUISupplier;
}

const SupplierDetailsTags = ({ supplier }: IProps) => {
  const styles = componentStyles();

  const maxVenueTypeTags = 1;
  const maxVenueStyleTags = 5;
  const maxTagsToDisplay = 10;
  const venueTypeTags = getVenueTags(venueTypes, supplier).slice(0, maxVenueTypeTags);
  const venueStyleTags = getVenueTags(venueStyles, supplier).slice(
    0,
    maxVenueStyleTags - venueTypeTags.length,
  );
  const venueFeatureTags = getVenueTags(venueFeatures, supplier).slice(
    0,
    maxTagsToDisplay - venueTypeTags.length - venueStyleTags.length,
  );

  if (!venueTypeTags.length && !venueStyleTags.length && !venueFeatureTags.length) {
    return null;
  }

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.rowWrap}>
        {venueTypeTags.map((venueType) => (
          <Box key={`venue-types-${venueType}`} style={styles.tagWrap}>
            <SupplierUpdateTag color="yellow">{venueType}</SupplierUpdateTag>
          </Box>
        ))}
        {venueStyleTags.map((venueStyle) => (
          <Box key={`venue-styles-${venueStyle}`} style={styles.tagWrap}>
            <SupplierUpdateTag color="yellow">{venueStyle}</SupplierUpdateTag>
          </Box>
        ))}
        {venueFeatureTags.map((venueFeature) => (
          <Box key={`venue-features-${venueFeature}`} style={styles.tagWrap}>
            <SupplierUpdateTag color="yellow">{venueFeature}</SupplierUpdateTag>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

function getVenueTags(supportedTags: string[], supplier: IUISupplier): string[] {
  return supportedTags
    .filter((supplierType) => Boolean(supplier[supplierType as keyof IUISupplier]))
    .map((supplierType) => msg[supplierType as MsgKey]?.())
    .filter((value) => value !== null) as string[];
}

export default SupplierDetailsTags;
